<template>
  <v-card dark class="show experience-organizations" v-if="experienceOrganization">
    <v-card-title primary-title>
      <LogoUpload
        :src="experienceOrganization.logo || '/img/missing/logos/institutions/original.png'"
        :path="`/admin/experience_organizations/${experienceOrganization.id}/logo`"
        @success="logoSuccess"
      />
      <div>
        <div class="headline">{{ experienceOrganization.name }}</div>
      </div>
    </v-card-title>
    <v-divider />

    <!-- Attributes table -->
    <table class="v-table theme--dark">
      <tbody>
        <tr>
          <th class="text-xs-right">ID</th>
          <td>{{ experienceOrganization.id }}</td>
        </tr>
        <tr>
          <th class="text-xs-right">Name</th>
          <td>
            {{ experienceOrganization.name }}
          </td>
        </tr>
        <tr>
          <th class="text-xs-right">Industry</th>
          <td>
            {{ experienceOrganization.industry }}
          </td>
        </tr>
        <tr>
          <th class="text-xs-right">Experiences</th>
          <td>
            {{ experienceOrganization.experiencesCount }}
          </td>
        </tr>
        <tr>
          <th class="text-xs-right">Last updated</th>
          <td>
            {{ new Date(experienceOrganization.updatedAt) | date('h:mm a, MMMM do yyyy') }}
            ({{ new Date(experienceOrganization.updatedAt) | inWords({ addSuffix: true }) }})
          </td>
        </tr>
      </tbody>
    </table>

    <v-divider />
    <v-card-actions>
      <v-spacer />
      <can I="delete" a="ExperienceOrganization">
        <v-dialog v-model="dialog" lazy absolute max-width="600">
          <v-btn flat slot="activator" color="error"> <v-icon left>mdi-delete</v-icon> Delete </v-btn>
          <v-card dark>
            <v-card-title class="headline">
              Are you sure?
            </v-card-title>
            <v-card-text>
              This action cannot be undone and will unlink this organization from all associated
              experiences.
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn flat color="grey" @click.native="dialog = false">cancel</v-btn>
              <v-btn color="error" @click="$emit('destroy')">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        </can>

        <can I="edit" a="ExperienceOrganization">
          <v-btn @click="$emit('edit')" color="primary"> <v-icon left>mdi-pencil</v-icon> Edit </v-btn>
        </can>
      </v-card-actions>
    </v-card>
  </template>

  <script>
  // Components
  import LogoUpload from '@/components/LogoUpload'

  // Helpers
  import { mapGetters } from 'vuex'

  // Vue Component
  export default {
    components: { LogoUpload },

    created() {
      this.$store.dispatch('admin/experience_organizations/fetch', this.$route.params.id)
    },

    data() {
      return { dialog: false }
  },

  computed: mapGetters({ experienceOrganization: 'admin/experience_organizations/find' }),

  methods: {
    logoSuccess() {
      this.$store.dispatch('snackbarSuccess', 'Logo uploaded')
      this.$store.dispatch('admin/experience_organizations/fetch', this.value.id)
    },
  },
}
</script>
